/**
 * Canonical text for a GitHub-style diff.
 *
 * Object key order is not part of the saved meaning, and JSONB can return keys
 * in a different order than the editor built. Arrays keep their order: tool
 * lists and procedure steps are sequences.
 */
export function stableJson(value: unknown): string {
  return `${JSON.stringify(canonicalize(value), null, 2) ?? 'null'}\n`;
}

/** A text file body with one trailing newline, so the last line is a real line. */
export function textFile(value: string): string {
  if (value.length === 0) return '';
  return value.endsWith('\n') ? value : `${value}\n`;
}

function canonicalize(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, child]) => [key, canonicalize(child)]),
    );
  }
  return value;
}
